import type { FileFormat } from '../../../../types';
import FilterByFileNameInput from './FilterByFileNameInput';
import useFilterByFilenameOptions from './hooks/useFilterByFilenameOptions';

interface FilterByFileNameInputContainerProps {
    fileFormat: FileFormat;
    switchIncludeAll: boolean;
    value: readonly string[];
    onChange: (value: readonly string[]) => void;
}

const FilterByFileNameInputContainer = ({
    fileFormat,
    switchIncludeAll,
    value,
    onChange,
}: FilterByFileNameInputContainerProps) => {
    const options = useFilterByFilenameOptions(fileFormat, switchIncludeAll);

    const inputValue = value.map((filename) => ({ value: filename, label: filename }));

    return (
        <FilterByFileNameInput
            value={inputValue}
            options={options}
            onChange={(val) => onChange(val.map((item) => item.value))}
        />
    );
};

export default FilterByFileNameInputContainer;
